

















































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CustomValueDisplay from "@/common/ui/components/CustomValueDisplay.vue";
import Status from "@/usecases/orders/purchase-status";

@Component({
  components: {
    CustomValueDisplay
  }
})
export default class SalesReportNewTables extends Vue {
  @Prop({ required: true }) data!: any;
  Status = Status;
  purchaseStatusOptions = [
    {
      text: "未発注",
      value: "created"
    },
    {
      text: "発注済み",
      value: "ordered"
    },
    {
      text: "送金済み",
      value: "paid"
    },
    {
      text: "実績保存済み",
      value: Status.ACTUAL_RESULT
    }
  ];

  invoiceStatusOptions = [
    {
      text: "未請求",
      value: "created"
    },
    {
      text: "請求済み",
      value: "requested"
    },
    {
      text: "入金済み",
      value: "paid"
    }
  ];

  getPurchaseOptionStatus(value: string) {
    const option = this.purchaseStatusOptions.find(
      option => option.value === value
    );
    return option ? option.text : "";
  }

  getInvoiceOptionStatus(value: string) {
    const option = this.invoiceStatusOptions.find(
      option => option.value === value
    );
    return option ? option.text : "";
  }
}
